import React, { useState } from "react";
import Tarjeta from "../components/Tarjeta";
import peliculas from "../db.json";
import estilo from "../styles/Busqueda.module.css";
import Paginacion from "../components/Paginacion";
import Estrenos from "../components/Estrenos";
import Ranking from "../components/Raking";
import MetaDecorator from "../utils/MetaDecorator";

function Busqueda() {
  const [input, setInput] = useState("");
  const submitHandler = (e) => {
    e.preventDefault();
  };
  // console.log(input);
  //
  const estrenos = peliculas
    .map(({ ...capitulos }) => ({ ...capitulos }))
    .filter((e) => e.filtrado.indexOf(input) > -1);
  // console.log(estrenos);
  //paginación
  const [elementoPagina, setElementoPagina] = useState(1);
  const [elementosPorPagina] = useState(12);
  const ultimoIndice = elementoPagina * elementosPorPagina;
  const primerIndice = ultimoIndice - elementosPorPagina;
  const elementosSalida = estrenos.slice(primerIndice, ultimoIndice);
  const paginacion = (numeroPagina) => setElementoPagina(numeroPagina);
  return (
    <div className={estilo.buscador}>
      <MetaDecorator
        titulo={"Buscador | RepelisPlus"}
        subtitulo={"Buscador | RepelisPlus"}
        descripcion={
          "Las mejores peliculas las encuentras en RepelisPlus, peliculas de estreno en alta calidad gratis."
        }
      />
      <div className={estilo.linea}></div>
      <Ranking></Ranking>
      <div className={estilo.linea}></div>
      <form onSubmit={submitHandler} className={estilo.formulario}>
        <input
          className={estilo.input}
          onChange={(e) => setInput(e.target.value.toLocaleLowerCase())}
          type="text"
          placeholder="Busqueda"
          value={input}
        />
        <svg width="30" height="30" fill="currentColor" viewBox="0 0 16 16">
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
        </svg>
      </form>

      <div className={estilo.grid_buscador}>
        {elementosSalida.map((e) => (
          <Tarjeta key={e.id} pelicula={e}></Tarjeta>
        ))}
      </div>

      <div>
        <Paginacion
          elementosPorPagina={elementosPorPagina}
          elementosTotales={estrenos.length}
          paginacion={paginacion}
          pag="pag"
        />
      </div>
      <div className={estilo.linea}></div>
      <Estrenos></Estrenos>
      <br></br>
    </div>
  );
}

export default Busqueda;
